// extracted by mini-css-extract-plugin
export default {"title":"CreditCard_title__sQ1Bk"};